import { useMemo } from 'react';
import { CurrencyUtils } from '@shared/utils';

export const useCurrencySymbol = (code?: string) => useMemo(() => CurrencyUtils.getSymbolByCode(code), [code]);
